import React, { useState } from 'react';
import { signInWithGoogle } from '../../services/auth/googleAuth';
import { useLocation } from 'react-router-dom';

export function GoogleSignInButton() {
  const [isLoading, setIsLoading] = useState(false);
  const location = useLocation();
  const isSignUp = location.pathname === '/create-account';

  const handleGoogleSignIn = async () => {
    if (isLoading) return;
    
    setIsLoading(true);
    try {
      await signInWithGoogle();
    } catch (error) {
      console.error('Google sign in error:', error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <button
      onClick={handleGoogleSignIn}
      disabled={isLoading}
      className="w-full flex items-center justify-center px-6 py-3 border border-black rounded-xl shadow-sm bg-white text-sm font-medium text-black hover:bg-gray-50 disabled:opacity-50"
    >
      <img
        src="https://www.google.com/favicon.ico"
        alt="Google"
        className="w-5 h-5 mr-2"
      />
      {isLoading ? 'Signing in...' : isSignUp ? 'Sign up with Google' : 'Sign in with Google'}
    </button>
  );
}